/* import __COLOCATED_TEMPLATE__ from './plaid-linking-flow.hbs'; */
var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import uuid from 'uuid-js';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { and } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import { Country } from '@square/dashboard-data/models/squareup/common/countries';
import { Button, CreateAndLinkBankAccountFromPlaidLinkSessionStep, CreatePlaidLinkSessionStep, PlaidLinkSessionAction, PlaidResultStep } from '@square/dashboard-protos/models/squareup/bbfrontend/common/bank_account/plaid_linking_models';
import { GlyphIcon } from '@square/dashboard-protos/models/squareup/bbfrontend/common/glyph/glyph_icon';
import { ButtonDescription } from '@square/dashboard-protos/models/squareup/bbfrontend/common/component/component';
import { LogEvent } from '@square/dashboard-protos/models/squareup/bbfrontend/common/workflow/ui_elements/common';
import { feature } from '@square/ember-features/macros';
import { CreatePlaidLinkSessionRequest, CreateAndLinkBankAccountFromPlaidLinkRequest } from '@square/dashboard-protos/models/squareup/bbfrontend/common/bank_account/bank_account_service';
import environment from '@square/environment-utils/environment';
import { Applet, Feature, Page, PlaidEventToPage, Target, getAccountOwnerRoleName } from '@banking/ui/utils/bank-linking-cdp-events';
import { ClientFlow } from '@banking/ui/utils/flexible-transfers-utils';
import BankingPlaidLinkingGbPlaidLinkManually from '@banking/ui/components/banking/plaid-linking/gb/plaid-link-manually';
var Screens = /*#__PURE__*/function (Screens) {
  Screens["CONSENT"] = "consent";
  Screens["LOADING"] = "loading";
  Screens["RESULT"] = "result";
  Screens["ACCOUNT_OWNER_ROLE"] = "account_owner_role";
  Screens["DIRECT_DEBIT_MANDATE"] = "direct_debit_mandate";
  Screens["TRANSFER_ACCOUNT_SELECTION"] = "transfer_account_selection";
  return Screens;
}(Screens || {});
let PlaidLinkingFlow = (_dec = service('bbfrontend/v1/bank-account'), _dec2 = feature('banking/enable_plaid_multibank_linking'), _dec3 = feature('truweb-blue-cta-button-ember-bucketing'), _dec4 = and('enablePlaidMultibankLinking', 'userInfo.isUS'), _class = class PlaidLinkingFlow extends Component {
  get enableGbPlaidBankLinkingV2() {
    return this.userInfo.countryCode === Country.GB;
  }

  // For the GB Plaid V2 flow and the onboarding plaid flow, the action buttons need to be displayed in the header.
  get showActionButtonsInHeader() {
    return this.currentScreen === Screens.CONSENT && this.enableGbPlaidBankLinkingV2 || !this.args.isDisplayedInsideModalPartial && this.currentScreen !== Screens.LOADING;
  }
  get headerActionButtons() {
    const step = this.screen?.step;
    if (this.showActionButtonsInHeader && step !== undefined && step instanceof CreatePlaidLinkSessionStep.PlaidLinkingStep && step.plaidConsent?.buttons) {
      // The consent buttons for GB v2 need to be in reverse order of the response from the server.
      return [...step.plaidConsent.buttons].sort((a, b) => (b.buttonDescription?.style ?? 0) - (a.buttonDescription?.style ?? 0));
    }
    if (!this.args.isDisplayedInsideModalPartial) {
      if (step instanceof CreatePlaidLinkSessionStep.PlaidLinkingStep && step.accountOwnerRole?.buttons) {
        return step.accountOwnerRole.buttons;
      }
      if (step instanceof CreateAndLinkBankAccountFromPlaidLinkSessionStep.CreateAndLinkBankAccountFromPlaidLinkStep && step.plaidDirectDebitMandateStep?.buttons) {
        return step.plaidDirectDebitMandateStep.buttons;
      }
    }
    return undefined;
  }
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "bankAccountService", _descriptor, this);
    _initializerDefineProperty(this, "logEvents", _descriptor2, this);
    _initializerDefineProperty(this, "intl", _descriptor3, this);
    _initializerDefineProperty(this, "userInfo", _descriptor4, this);
    _initializerDefineProperty(this, "modal", _descriptor5, this);
    _initializerDefineProperty(this, "isButtonLoading", _descriptor6, this);
    _initializerDefineProperty(this, "currentScreen", _descriptor7, this);
    _initializerDefineProperty(this, "screen", _descriptor8, this);
    _initializerDefineProperty(this, "copyToken", _descriptor9, this);
    _initializerDefineProperty(this, "accountHolderRelationshipToBusiness", _descriptor10, this);
    _initializerDefineProperty(this, "errorMessage", _descriptor11, this);
    _initializerDefineProperty(this, "sessionToken", _descriptor12, this);
    _initializerDefineProperty(this, "plaidLinkToken", _descriptor13, this);
    _initializerDefineProperty(this, "directDebitIdempotenceKey", _descriptor14, this);
    _initializerDefineProperty(this, "selectedBankAccount", _descriptor15, this);
    _initializerDefineProperty(this, "isPlaidModalActive", _descriptor16, this);
    // 10/18/2024: There are now two feature flags that manage the Plaid linking flow.
    // Enable_plaid_multibank_linking will force sellers to link all of their bank
    // accounts. Turning it off will enable the Plaid single account linking flow.
    // The deposits/enable-plaid-bank-linking flag controls the Plaid single linking flow
    // and turning that off will fallback to the manual bank linking flow.
    _initializerDefineProperty(this, "enablePlaidMultibankLinking", _descriptor17, this);
    _initializerDefineProperty(this, "blueCtaButtonBucket", _descriptor18, this);
    _initializerDefineProperty(this, "showPlaidMultibankLinking", _descriptor19, this);
    _defineProperty(this, "plaidInfo", void 0);
    _defineProperty(this, "errorResponse", void 0);
    _defineProperty(this, "plaidConfig", void 0);
    this.errorResponse = CreatePlaidLinkSessionStep.create({
      identifier: 'result_screen',
      viewLogEvent: LogEvent.create({
        applet: 'Banking',
        feature: 'Add Bank Account',
        page: 'Something Went Wrong',
        action: LogEvent.Action.VIEW
      }),
      step: CreatePlaidLinkSessionStep.PlaidLinkingStep.create({
        plaidResultStep: PlaidResultStep.create({
          icon: GlyphIcon.EXCLAMATION_TRIANGLE,
          iconStyle: PlaidResultStep.IconStyle.WARNING,
          title: this.intl.t('banking.plaidLinking.error.genericHeader'),
          description: this.intl.t('banking.plaidLinking.error.genericDescription'),
          buttons: [Button.create({
            identifier: 'ok_button',
            buttonDescription: ButtonDescription.create({
              text: this.intl.t('banking.plaidLinking.error.buttonLabel'),
              style: ButtonDescription.ButtonStyle.BUTTON_STYLE_PRIMARY,
              variant: ButtonDescription.ButtonVariant.BUTTON_VARIANT_NORMAL
            }),
            plaidLinkSessionAction: PlaidLinkSessionAction.create({
              navigation: PlaidLinkSessionAction.Navigation.FINISH
            })
          })]
        })
      })
    });
    this.directDebitIdempotenceKey = this.userInfo.countryCode === Country.GB ? uuid.create().toString() : undefined;
    this.plaidConfig = {
      clientName: '',
      product: ['auth'],
      countryCodes: [this.userInfo.countryCode],
      env: environment().isProduction ? 'production' : 'sandbox'
    };
  }
  get showNavigation() {
    return this.currentScreen !== Screens.RESULT;
  }
  get showBackButton() {
    return !this.args.isDisplayedInsideModalPartial && this.currentScreen === Screens.ACCOUNT_OWNER_ROLE;
  }
  async requestNextStep(args) {
    const {
      submission
    } = args;
    if (submission) {
      this.isButtonLoading = true;
    }
    try {
      const response = await this.bankAccountService.client.createPlaidLinkSession({
        merchantToken: this.args.flowOptions.merchantToken,
        submission
      });
      this.handleReceivedStep(response);
    } catch (error) {
      // If user aborted step-up auth, close gracefully without error
      if (error?.message?.includes('AUTHZ_ENGINES_ABORTED')) {
        this.args.onClose?.({
          shouldRefresh: false
        });
        return;
      }
      this.onPlaidError();
    }
  }
  handleReceivedStep(response) {
    if (response.submissionError) {
      this.errorMessage = response.submissionError;
      this.isButtonLoading = false;
      return;
    }

    // Handle response that renders the plaid flow screens
    if (response.step) {
      this.screen = response.step;
      if (response.step.viewLogEvent) {
        this.logEvents.track(response.step.viewLogEvent, response.step.viewLogEvent?.dynamicProperties);
      }
      if (response.step.step?.plaidConsent) {
        this.copyToken = response.step.step.plaidConsent.copyToken;
        this.currentScreen = Screens.CONSENT;
      } else if (response.step.step?.accountOwnerRole) {
        this.isButtonLoading = false;
        this.currentScreen = Screens.ACCOUNT_OWNER_ROLE;
      } else {
        this.currentScreen = Screens.RESULT;
      }
      return;
    }

    // Handle response that launches Plaid Linking flow
    if (response.session) {
      this.sessionToken = response.session.sessionToken;
      this.plaidLinkToken = response.session.linkToken;
      // The ember-plaid-link library opens the plaid modal when it is clicked
      const plaidModal = document.querySelector('.plaid-linking-modal__plaid-link');
      if (!plaidModal) {
        return;
      }
      plaidModal.click();
      this.currentScreen = Screens.LOADING;
      this.isPlaidModalActive = true;
    }
  }
  updateAccountOwnerRole(accountHolderRelationshipToBusiness) {
    this.accountHolderRelationshipToBusiness = accountHolderRelationshipToBusiness;
  }
  updateSelectedBankAccount(selectedBankAccount) {
    this.selectedBankAccount = selectedBankAccount;
  }
  updateStep(selectedElement) {
    this.errorMessage = '';
    let dynamicProperties = {};
    if (this.currentScreen === Screens.ACCOUNT_OWNER_ROLE && this.accountHolderRelationshipToBusiness) {
      dynamicProperties = {
        account_owner_relationship: getAccountOwnerRoleName(this.accountHolderRelationshipToBusiness)
      };
    }
    if (selectedElement.plaidLinkSessionAction?.clickLogEvent) {
      this.logEvents.track(selectedElement.plaidLinkSessionAction.clickLogEvent, dynamicProperties);
    }
    if (selectedElement.plaidLinkSessionAction?.navigation) {
      this.handleNavigationAction(selectedElement.plaidLinkSessionAction.navigation);
    }
    if (selectedElement.plaidLinkSessionAction?.clientFlow) {
      this.handleClientFlowAction(selectedElement.plaidLinkSessionAction.clientFlow);
    }
  }
  handleNavigationAction(navigation) {
    if (navigation === PlaidLinkSessionAction.Navigation.FINISH) {
      this.resetState();
      if (this.args.onClose) {
        this.args.onClose({
          shouldRefresh: true
        });
      }
      return;
    }

    // for GB flows, when navigation is NEXT and current screen is DDM screen,
    // we need to call CreateAndLinkBankAccountFromPlaidLink for the second time
    // to link the bank account.
    if (this.currentScreen === Screens.DIRECT_DEBIT_MANDATE) {
      this.callCreateAndLinkBankAccountFromPlaidLink(CreateAndLinkBankAccountFromPlaidLinkRequest.CreateAndLinkBankAccountFromPlaidLinkStep.CONFIRM_DIRECT_DEBIT_MANDATE);
      this.currentScreen = Screens.LOADING;
    } else if (this.currentScreen === Screens.TRANSFER_ACCOUNT_SELECTION && this.selectedBankAccount) {
      this.onSelectTransferAccount(this.selectedBankAccount);
      this.currentScreen = Screens.LOADING;
    } else {
      let consent;
      let multiBankConsent;
      if (this.showPlaidMultibankLinking) {
        multiBankConsent = CreatePlaidLinkSessionRequest.MultiBankConsentSubmission.create({
          copyToken: this.copyToken,
          accountHolderRelationshipToBusiness: this.accountHolderRelationshipToBusiness
        });
      } else {
        consent = CreatePlaidLinkSessionRequest.ConsentSubmission.create({
          copyToken: this.copyToken,
          accountHolderRelationshipToBusiness: this.accountHolderRelationshipToBusiness
        });
      }
      this.requestNextStep({
        submission: CreatePlaidLinkSessionRequest.CreatePlaidLinkSessionSubmission.create({
          stepIdentifier: this.screen?.identifier,
          consent,
          multiBankConsent
        })
      });
    }
  }
  async handleClientFlowAction(clientFlow) {
    let flow = undefined;
    if (Object.prototype.hasOwnProperty.call(clientFlow, 'linkBankAccount')) {
      if (this.enableGbPlaidBankLinkingV2) {
        const continueWithManualLinking = await this.modal.open(BankingPlaidLinkingGbPlaidLinkManually, {
          isDisplayedInsideModalPartial: this.args.isDisplayedInsideModalPartial,
          blueCtaButtonBucket: this.blueCtaButtonBucket
        });
        if (continueWithManualLinking === undefined) {
          return;
        }
        if (!continueWithManualLinking) {
          return this.handleNavigationAction(PlaidLinkSessionAction.Navigation.NEXT);
        }
      }
      flow = ClientFlow.LINK_BANK_ACCOUNT;
    } else if (Object.prototype.hasOwnProperty.call(clientFlow, 'linkDebitCard')) {
      flow = ClientFlow.LINK_DEBIT_CARD;
    }
    this.resetState();
    if (this.args.onClose) {
      this.args.onClose({
        shouldRefresh: false,
        nativeFlow: flow
      });
    }
  }
  resetState() {
    this.currentScreen = Screens.LOADING;
    this.screen = undefined;
    this.copyToken = '';
    this.accountHolderRelationshipToBusiness = undefined;
    this.errorMessage = '';
    this.sessionToken = '';
    this.plaidLinkToken = '';
    this.directDebitIdempotenceKey = '';
    this.selectedBankAccount = '';
    this.isButtonLoading = false;
    this.isPlaidModalActive = false;
  }
  onPlaidSuccess(public_token, metadata) {
    this.plaidInfo = {
      plaidPublicToken: public_token,
      plaidMetadata: metadata
    };
    this.isPlaidModalActive = false;
    this.callCreateAndLinkBankAccountFromPlaidLink(CreateAndLinkBankAccountFromPlaidLinkRequest.CreateAndLinkBankAccountFromPlaidLinkStep.INITIALIZE);
  }
  onSelectTransferAccount(bankToken) {
    this.callCreateAndLinkBankAccountFromPlaidLink(CreateAndLinkBankAccountFromPlaidLinkRequest.CreateAndLinkBankAccountFromPlaidLinkStep.SELECT_BANK_ACCOUNT, bankToken);
  }
  async callCreateAndLinkBankAccountFromPlaidLink(step, bankToken) {
    const {
      unitToken,
      isFlexibleTransferUnifiedLinkBankAccountFlow
    } = this.args.flowOptions;
    let singleSelection;
    let multipleSelection;
    let submission;
    let selectedPlaidBankAccountId;
    if (step === CreateAndLinkBankAccountFromPlaidLinkRequest.CreateAndLinkBankAccountFromPlaidLinkStep.SELECT_BANK_ACCOUNT && bankToken) {
      submission = {
        stepIdentifier: step.toString(),
        bankAccount: {
          bankAccountToken: bankToken
        }
      };
    } else {
      if (this.showPlaidMultibankLinking) {
        multipleSelection = {
          selectedPlaidBankAccountIds: this.plaidInfo?.plaidMetadata.accounts.map(account => account.id)
        };
      } else {
        selectedPlaidBankAccountId = this.plaidInfo?.plaidMetadata?.account_id;
        singleSelection = {
          selectedPlaidBankAccountId
        };
      }
    }
    try {
      const response = await this.bankAccountService.client.createAndLinkBankAccountFromPlaidLink({
        plaidLinkSessionResults: {
          sessionToken: this.sessionToken,
          context: isFlexibleTransferUnifiedLinkBankAccountFlow ? CreateAndLinkBankAccountFromPlaidLinkRequest.Context.LINK_BANK_THEN_DEBIT_CARD_IF_NECESSARY : CreateAndLinkBankAccountFromPlaidLinkRequest.Context.LINK_BANK_ACCOUNT,
          plaidPublicToken: this.plaidInfo?.plaidPublicToken,
          bankName: this.plaidInfo?.plaidMetadata?.institution?.name,
          bankAccountNumberMask: this.plaidInfo?.plaidMetadata?.accounts[0].mask == null ? undefined : this.plaidInfo?.plaidMetadata?.accounts[0].mask,
          bankAccountName: this.plaidInfo?.plaidMetadata?.accounts?.[0]?.name,
          singleSelection,
          multipleSelection
        },
        context: isFlexibleTransferUnifiedLinkBankAccountFlow ? CreateAndLinkBankAccountFromPlaidLinkRequest.Context.LINK_BANK_THEN_DEBIT_CARD_IF_NECESSARY : CreateAndLinkBankAccountFromPlaidLinkRequest.Context.LINK_BANK_ACCOUNT,
        submission,
        unitToken,
        accountHolderRelationshipToBusiness: this.accountHolderRelationshipToBusiness,
        step,
        directDebitMandateIdempotenceKey: this.directDebitIdempotenceKey
      });
      if (response.resultStep) {
        return this.handleBankLinkingResultStep(response.resultStep);
      }
      if (response.clientFlow) {
        return this.handleClientFlowAction(response.clientFlow);
      }
    } catch (error) {
      // If user aborted step-up auth, close gracefully without error
      if (error?.message?.includes('AUTHZ_ENGINES_ABORTED')) {
        this.args.onClose?.({
          shouldRefresh: false
        });
        return;
      }
      this.onPlaidError();
    }
  }
  handleBankLinkingResultStep(step) {
    this.screen = step;
    if (step.step?.plaidResultStep && !this.args.isDisplayedInsideModalPartial && this.args.onPlaidLinkCompleted) {
      this.currentScreen = Screens.LOADING;
      this.args.onPlaidLinkCompleted();
      return;
    }
    if (step.step?.plaidResultStep) {
      this.currentScreen = Screens.RESULT;
    } else if (step.step?.plaidDirectDebitMandateStep) {
      this.currentScreen = Screens.DIRECT_DEBIT_MANDATE;
    } else if (step.step?.multipleBankAccountsStep && this.showPlaidMultibankLinking) {
      const selectedRow = step.step.multipleBankAccountsStep.bankAccountRows.find(row => row.isSelected);
      if (selectedRow) {
        this.updateSelectedBankAccount(selectedRow.value);
      }
      this.currentScreen = Screens.TRANSFER_ACCOUNT_SELECTION;
    }
    if (step.viewLogEvent) {
      this.logEvents.track(step.viewLogEvent, step.viewLogEvent?.dynamicProperties);
    }
  }
  onPlaidError() {
    this.screen = this.errorResponse;
    this.currentScreen = Screens.RESULT;
  }
  onPlaidExit() {
    this.logEvents.track(LogEvent.create({
      applet: Applet.Banking,
      feature: Feature.AddBankAccount,
      page: Page.PlaidIntro,
      action: LogEvent.Action.CLICK,
      target: Target.Exit
    }));
    this.resetState();
    if (this.args.onClose && this.args.isDisplayedInsideModalPartial) {
      this.args.onClose({
        shouldRefresh: false,
        nativeFlow: ClientFlow.LINK_BANK_ACCOUNT
      });
    } else {
      window.location.reload();
    }
  }
  onAllEvents(eventName, metadata) {
    // We only want to log the transition view event for "Select Accounts" and "Consent" screens.
    if (eventName === 'TRANSITION_VIEW' && metadata?.view_name !== 'SELECT_ACCOUNT' && metadata?.view_name !== 'CONSENT') {
      return;
    }
    const pageName = PlaidEventToPage[eventName];
    let transitionViewName = '';
    if (pageName === PlaidEventToPage.TRANSITION_VIEW) {
      if (metadata?.view_name === 'SELECT_ACCOUNT') {
        transitionViewName = Page.AccountSelection;
      } else if (metadata?.view_name === 'CONSENT') {
        transitionViewName = Page.PlaidIntro;
      }
    }
    if (pageName) {
      this.logEvents.track(LogEvent.create({
        applet: Applet.Banking,
        feature: Feature.AddBankAccount,
        page: pageName === PlaidEventToPage.TRANSITION_VIEW ? transitionViewName : pageName,
        action: LogEvent.Action.VIEW
      }));
    }
  }
  getPlaidToken() {
    return Promise.resolve(this.plaidLinkToken);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "bankAccountService", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "logEvents", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "modal", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "isButtonLoading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "currentScreen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return Screens.LOADING;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "screen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "copyToken", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "accountHolderRelationshipToBusiness", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "errorMessage", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "sessionToken", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "plaidLinkToken", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "directDebitIdempotenceKey", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "selectedBankAccount", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "isPlaidModalActive", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "enablePlaidMultibankLinking", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "blueCtaButtonBucket", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "showPlaidMultibankLinking", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "requestNextStep", [action], Object.getOwnPropertyDescriptor(_class.prototype, "requestNextStep"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateAccountOwnerRole", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateAccountOwnerRole"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateSelectedBankAccount", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateSelectedBankAccount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateStep", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateStep"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetState", [action], Object.getOwnPropertyDescriptor(_class.prototype, "resetState"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onPlaidSuccess", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onPlaidSuccess"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onPlaidError", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onPlaidError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onPlaidExit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onPlaidExit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onAllEvents", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onAllEvents"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getPlaidToken", [action], Object.getOwnPropertyDescriptor(_class.prototype, "getPlaidToken"), _class.prototype), _class);
export { PlaidLinkingFlow as default };